import Vue from 'vue'
import VueRouter from 'vue-router'
// import { Toast } from 'vant'
import store from '@/store'
// import i18n from './i18n';

// PC 端路由
import pcRouter from "./pc.js";
// import eventListener from '@/common/eventListener.js'

// 移动端页面
import mobileRouter from "@/views/mobile/template.vue";
import mobileR from "./mobile.js";

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes: [

		// 移动端路由 
		{
			path: "/mobile",
			name: "mobile",
			component: mobileRouter,
			children: mobileR
		},
		// PC 端路由 
		{
			...pcRouter
		},

		// 默认跳转
		{
			path: '*',
			redirect: '/pc/login'
		},
	],
	scrollBehavior() {
		// 总是回到顶部
		return { x: 0, y: 0 }
	}

})


//白名单路由 | 路由配置 isChecking = true
// const pathUrl = ['/login']
//跳转前拦截
router.beforeEach((to, from, next) => {
	// console.log(to, from, '路由拦截')
	const token = store.state.token
	const isMobile = store.state.isMobile

	// 手机端访问 PC 登录页 → 跳转手机登录页
	if (to.fullPath === '/pc/login' && isMobile) {
		return next({ path: '/mobile/login', replace: true })
	}

	// 已登录用户访问登录页 → 跳转首页
	if (token && ['/mobile/login', '/pc/login'].includes(to.fullPath)) {
		if (isMobile) {
			return next({ path: '/mobile/home', replace: true })
		} else {
			return next({ path: '/pc/home', replace: true })
		}
	}
	// 其他情况放行
	next()


	// if (to.fullPath === '/pc/login' && store.state.isMobile) {
	// 	next({ path: '/mobile/login', replace: true })
	// } else {
	// 	next()
	// }
	// console.log('路由：',to)  
	//   const token = store.state.TOKEN
	//   const path = to.path 
	//   if (pathUrl.includes(path) || to.meta.isChecking) {
	//     next()
	//   } else if (token) { 
	//     if (to.meta.isAdmin) { 
	//     }
	//     next();
	//   } else { 
	// 		Toast.fail('重新登陆')
	//     router.replace('/login')
	//   }
});
//跳转后拦截
router.afterEach(() => { });


export default router